import { createAction } from 'redux-actions';

export const doShowModal = createAction('SHOW-MODAL');
export const doHideModal = createAction('HIDE-MODAL');
